import EventTarget from '../data/EventTarget';

export default class ChartRowEventTarget extends EventTarget {
	constructor(params) {
		super(params);
	}
}
